<script setup>
const props = defineProps({
  text: {
    type: String,
    default() {
      return '';
    },
  },
  isError: {
    type: Boolean,
    default() {
      return false;
    },
  },
});
</script>

<template>
  <div
    :class="{ 'ui-help_error': isError }"
    class="ui-help"
  >
    <slot>
      <div v-html="text" />
    </slot>
  </div>
</template>

<style lang="scss">
.ui-help {
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: #352705;
  text-align: left;

  &_error {
    color: #ff5c70;
  }
}
</style>
